import React from 'react';
import { createRoot } from 'react-dom/client';
import { AppWrapper } from './AppWrapper';
import './styles/main.css';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');

const root = createRoot(rootElement);

// Wrap the render in requestAnimationFrame to ensure DOM is ready
requestAnimationFrame(() => {
  // Only use StrictMode in development
  if (import.meta.env.DEV) {
    console.log('Running in development mode with StrictMode enabled');
    root.render(
      <React.StrictMode>
        <AppWrapper />
      </React.StrictMode>
    );
  } else {
    console.log('Running in production mode with StrictMode disabled');
    root.render(<AppWrapper />);
  }
});
